module.exports = __webpack_public_path__ + "static/media/10.5c4af698.jpeg";